import React, { useState, useEffect } from "react";
import { app, FrameContexts } from "@microsoft/teams-js";
import { useNavigate } from "react-router-dom";
import { Button, FluentProvider, webLightTheme } from '@fluentui/react-components';
import "../styles/TranscriptConsent.scss";

const NoAccessScene = () => {
  const [ready, setReady] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const initializeApp = async () => {
      await app.initialize();
      try {
        const context = await app.getContext();

        if (context.page.frameContext !== FrameContexts.sidePanel) {
          setReady(false);
          return;
        }

        setReady(true);
      } catch (error) {
        setReady(false);
      }
    };

    initializeApp();
  }, []);

  if (!ready) {
    return (
      <div style={{ padding: "16px" }}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <FluentProvider theme={webLightTheme}>
      <div style={{ display: "flex", flexDirection: "column", height: "90vh", padding: "16px" }}>
        <div style={{ marginTop: "16px" }}>
          <h4>Health Partners Note Assistant</h4>
          <p>ACAB/MR/25/9043</p>
        </div>

        <div style={{ marginTop: "24px" }}>
          <p>Sorry, you don't currently have access to this app. If you feel this is wrong please open a support ticket and we can grant you access.</p>
        </div>

      </div>
    </FluentProvider>
  );
};

export default NoAccessScene;
